import React from 'react';
import { McmContactManager } from '@/features/mcm-contacts/components/McmContactManager';

export const ControlSettingsPage: React.FC = () => {
  return (
    <div>
      <McmContactManager />
    </div>
  );
};
